import { useApolloClient } from '@apollo/client';
import gql from 'graphql-tag';


export const buildTranslateObject = translations => {
	const translationObject = {};
	translations.forEach(translation => {
		translationObject[translation.label] = translation.text;
	});
	return translationObject;
};

export const initUserData = () => async dispatch => {
	const client = useApolloClient();
	const response = await client.query({
		query: gql`
			query Me {
				me {
					name
					surname
					id
					type
					actived
					roles
					phone
					email
					preferredLanguage
				}
			}
		`,
	});
	if (!response.errors) {
		if (response.data.me) {
			dispatch({
				type: 'SET_USER_DATA',
				value: response.data.me
			});
			// dispatch(setLanguage(response.data.me.preferredLanguage));
		}
	} else {
		// eslint-disable-next-line no-unused-expressions
		response.errors[0].code === 440
			&& sessionStorage.removeItem('token');
	}
};

// falta lo de los idiomas


const earlyVoteStructore = (portal, earlyVotes) => {
	const { agendas } = portal.council;
	const votes = Array.from(earlyVotes.values());
	const preVotes = [];
	agendas.forEach(agenda => {
		votes.forEach(vote => {
			if (agenda.id === vote?.agendaId) {
				preVotes.push({
					id: vote.agendaId,
					value: vote.value,
					name: agenda.agendaSubject
				});
			}
		});
	});
	return preVotes;
};

export const participantStruture = ({
	portal,
	participant,
	representative,
	earlyVotes
}) => {
	let preParticipant = {};
	const { repeatEmail, representative: representativeList, ...participantRequest } = participant;
	const votes = earlyVoteStructore(portal, earlyVotes);


	if (representative) {
		if (Object.keys(representative).length > 0) {
			representativeList.push({
				name: 'Delegación de voto en',
				value: representative.name,
				info: [
					{
						name: 'Miembro del Consejo',
						value: ''
					},
					{
						name: 'Nombre y apellidos del representante / Denominación social',
						value: representative.name,
					},
					{
						name: 'DNI del representante',
						value: representative.dni
					},
					{
						name: 'Email del representante',
						value: representative.email
					},
					{
						name: 'Telefono del representante',
						value: representative.phone || ''
					}]
			});
		}
		preParticipant = {
			...participantRequest,
			representative: representativeList,
			attachments: Object.keys(participant.attachments).map(key => participant.attachments[key]),
			earlyVotes: votes
		};
		return preParticipant;
	}

	preParticipant = {
		...participantRequest,
		attachments: Object.keys(participant.attachments).map(key => participant.attachments[key]),
		earlyVotes: votes
	};

	return preParticipant;
};
